import { render } from "./Main.vue?vue&type=template&id=fafbff88&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=fafbff88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fafbff88"

export default script